export default __webpack_public_path__ + "static/media/IMG_8068.ddfd2caf.jpg";